<!-- TEMPLATE: Drawer.vue -->

<script setup lang="ts">
//
// Imports
//
import DrawerHeader from "../organisms/DrawerHeader.vue";
import DrawerSection from "../organisms/DrawerSection.vue";

//
// Composables
//
const {
  drawer,
  drawerRailMode,
  overviewItems,
  aboutItems,
  devItems,
  laboratoryLogoUrl,
  labName,
  initializeDrawer,
} = useDrawer();

// Initialize drawer with laboratory data
onMounted(() => {
  initializeDrawer();
});

//
// Initial Setup
//

// Localization
const { t } = useI18n();

//
// Props
//
defineProps<{
  appLogo?: string;
  appName?: string;
  userName?: string;
  userEmail?: string;
}>();
</script>

<template>
  <v-navigation-drawer v-model="drawer" app :rail="drawerRailMode">
    <!-- Header Section -->
    <drawer-header
      :app-logo-expanded-mode="laboratoryLogoUrl"
      :app-logo-rail-mode="laboratoryLogoUrl"
      :app-name="labName"
      :user-name="userName"
      :user-email="userEmail"
    />

    <v-divider />

    <!-- Main Navigation Sections -->
    <drawer-section
      :title="
        drawerRailMode
          ? ''
          : t('components.common.navigation-drawer.drawer_sections.overview_section.title')
      "
      :items="overviewItems"
    />

    <!-- Dev Section (only visible when LAB_PORTAL_FE_DEV=true) -->
    <template v-if="devItems.length > 0">
      <v-divider />
      <drawer-section
        :title="
          drawerRailMode
            ? ''
            : t('components.common.navigation-drawer.drawer_sections.dev_section.title')
        "
        :items="devItems"
      />
    </template>

    <!-- Footer Section -->
    <template #append>
      <v-divider />

      <drawer-section :items="aboutItems" />
    </template>
  </v-navigation-drawer>
</template>
